import MainContainer from "./MainContainer"
import SecondContainer from "./SecondContainer"
import ThirdContainer from "./ThirdContainer"


function HomePage(){
    return(
        <div>
            <MainContainer />
            <SecondContainer />
            <ThirdContainer />
        </div>
    )
}

export default HomePage;